import { render } from "./SVM.vue?vue&type=template&id=706cdc16"
import script from "./SVM.vue?vue&type=script&lang=js"
export * from "./SVM.vue?vue&type=script&lang=js"

import "./SVM.vue?vue&type=style&index=0&id=706cdc16&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__